import React from 'react';
import { FormGroup, Label } from 'reactstrap';
import { FormattedMessage, useIntl } from 'react-intl';

const ReduxFormTextarea: React.FC = (field: any) => (
  <FormGroup row={false}>
    {field.label && (<Label><FormattedMessage {...field.label} /></Label>)}
    <textarea rows={field.rows ?? 5} className="form-control"
              {...field.input}
              type={field.type}
              placeholder={field.placeHolder ? useIntl().formatMessage(field.placeHolder) : null}
              disabled={field.disabled}
    />
    {field.meta.touched && field.meta.error && (
      <p className="text-danger"><FormattedMessage id={field.meta.error} /></p>
    )}
  </FormGroup>
);

export default ReduxFormTextarea;